// Action Types
export const VM_SET_COUNTRIES = "VM_SET_COUNTRIES";
export const VM_SET_CITIES = "VM_SET_CITIES";
export const VM_SET_DOMAINS = "VM_SET_DOMAINS";
export const VM_SET_SUB_DOMAINS = "VM_SET_SUB_DOMAINS";
export const VM_SET_LANGUAGES = "VM_SET_LANGUAGES";
export const VM_SET_NATIONALITIES = "VM_SET_NATIONALITIES";
export const VM_SET_SERVICES = "VM_SET_SERVICES";
export const VM_SET_TIMEZONES = "VM_SET_TIMEZONES";
export const VM_SET_CURRENCIES = "VM_SET_CURRENCIES";
export const VM_SET_PO_STATUSES = "VM_SET_PO_STATUSES";
export const VM_SET_BILLING_ENTITY = "VM_SET_BILLING_ENTITY";
export const VM_RESET_LOOKUPS = "VM_RESET_LOOKUPS";

// Fetch Actions
export const VM_FETCH_COUNTRIES = "VM_FETCH_COUNTRIES";
export const VM_FETCH_CITIES = "VM_FETCH_CITIES";
export const VM_FETCH_DOMAINS = "VM_FETCH_DOMAINS";
export const VM_FETCH_SUB_DOMAINS = "VM_FETCH_SUB_DOMAINS";
export const VM_FETCH_LANGUAGES = "VM_FETCH_LANGUAGES";
export const VM_FETCH_NATIONALITIES = "VM_FETCH_NATIONALITIES";
export const VM_FETCH_SERVICES = "VM_FETCH_SERVICES";
export const VM_FETCH_TIMEZONES = "VM_FETCH_TIMEZONES";
export const VM_FETCH_CURRENCIES = "VM_FETCH_CURRENCIES";
export const VM_FETCH_PO_STATUSES = "VM_FETCH_PO_STATUSES";
export const VM_FETCH_BILLING_ENTITY = "VM_FETCH_BILLING_ENTITY";

// Action Creators
export const setCountries = (data) => ({ type: VM_SET_COUNTRIES, data });
export const setCities = (data) => ({ type: VM_SET_CITIES, data });
export const setDomains = (data) => ({ type: VM_SET_DOMAINS, data });
export const setSubDomains = (data) => ({ type: VM_SET_SUB_DOMAINS, data });
export const setLanguages = (data) => ({ type: VM_SET_LANGUAGES, data });
export const setNationalities = (data) => ({
  type: VM_SET_NATIONALITIES,
  data,
});
export const setServices = (data) => ({ type: VM_SET_SERVICES, data });
export const setTimezones = (data) => ({ type: VM_SET_TIMEZONES, data });
export const setCurrencies = (data) => ({ type: VM_SET_CURRENCIES, data });
export const setPoStatuses = (data) => ({ type: VM_SET_PO_STATUSES, data });
export const setBillingEntity = (data) => ({
  type: VM_SET_BILLING_ENTITY,
  data,
});
export const resetLookups = () => ({ type: VM_RESET_LOOKUPS });

// Fetch Action Creators
export const fetchCountries = () => ({ type: VM_FETCH_COUNTRIES });
export const fetchCities = (countryId) => ({
  type: VM_FETCH_CITIES,
  countryId,
});
export const fetchDomains = () => ({ type: VM_FETCH_DOMAINS });
export const fetchSubDomains = (domainIds) => ({
  type: VM_FETCH_SUB_DOMAINS,
  domainIds,
});
export const fetchLanguages = () => ({ type: VM_FETCH_LANGUAGES });
export const fetchNationalities = () => ({ type: VM_FETCH_NATIONALITIES });
export const fetchServices = () => ({ type: VM_FETCH_SERVICES });
export const fetchTimezones = (countryId) => ({
  type: VM_FETCH_TIMEZONES,
  countryId,
});
export const fetchCurrencies = () => ({ type: VM_FETCH_CURRENCIES });
export const fetchPoStatuses = () => ({ type: VM_FETCH_PO_STATUSES });
export const fetchBillingEntity = () => ({ type: VM_FETCH_BILLING_ENTITY });
